<template>
  <section aria-label="quick summary" class="article-header px-md-9 px-0">
    <card-header :card="data" isArticlePage class="article-header__info" />
    <h1 class="article-header__title mb-6" itemprop="headline">{{data.title}}</h1>
    <p class="article-header__preview-text" itemprop="about" v-if="data.preview_text !== 'null'">{{data.preview_text}}</p>

    <div class="d-flex d-md-none align-items-center mb-6">
      <span class="article-card__views mr-6 isArticlePage">
        <i class="icon-views-eye"></i>
        {{ data.quant_user_views }} просмотров
      </span>
      <time
        class="article-card__dateCreate isArticlePage d-md-none d-inline-block mr-6"
        itemprop="datePublished"
        :datetime="new Date(data.public_date).toISOString()"
      >{{ data.public_date | date('date') }}</time>
    </div>

    <div class="article-header__buttons-block mb-9">
      <div class="share">
        <bim-button @click="openShare = !openShare" id="shareBtn" color="gray" ref="shareBtn" size="s" :square="$windowWidth <= 575" icon="icon-share2" label="Поделиться" />
        <div class="share-btn-block" :class="{'d-none': !openShare}">
          <a class="social-link fb mr-3" rel="nofollow" href="" @click.prevent="openLink('fb')" target="_blank">
            <i class="icon-facebook center"></i>
          </a>
          <a class="social-link tw mr-3" rel="nofollow" href="" @click.prevent="openLink('tw')" target="_blank">
            <i class="icon-twitter center"></i>
          </a>
          <a class="social-link vk" rel="nofollow" href="" @click.prevent="openLink('vk')" target="_blank">
            <i class="icon-vk2 center"></i>
          </a>
        </div>
      </div>
    </div>
    <img class="article-header__head_img mb-9" width="100%" ref="headerImage" v-if="data.head_img !== 'null'" :src="`/uploads${data.head_img}?size=${imageWidth}x-`" :alt="data.title">
  </section >
</template>

<script>
import cardHeader from './../CardHeader'
  export default {
    components: {
      cardHeader,
    },
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        openShare: false,
        imageWidth: 1200,
      }
    },
    mounted() {
      this.clickOutside();
      this.calculateImageWidth();
      window.addEventListener("resize", this.calculateImageWidth)
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.calculateImageWidth)
    },
    methods: {
      async calculateImageWidth() {
        await this.$nextTick()
        setTimeout(( ) => {
          this.imageWidth = this.$refs.headerImage.clientWidth
        }, 0)
      },
      /**
       * Открывает окошко "Поделиться" нужной соцсети в зависимости от переданного параметра
       * @param {string} social - сокращенное название соц-сети
       */
      openLink(social) {
        switch (social) {
          case 'vk':
            window.open(`https://vk.com/share.php?url=${window.location.href}&title=${this.data.title}&image=${this.data.index_img}&description=&noparse=true`, 'share', 'width=600,height=400');
            break;
          case 'fb':
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&title=${this.data.title}&image=${this.data.index_img}&description=&noparse=true`, 'share', 'width=600,height=400');
            break;
          case 'tw':
            window.open(`https://twitter.com/share?url=${window.location.href}&title=${this.data.title}&image=${this.data.index_img}&description=&noparse=true`, 'share', 'width=600,height=400');
            break;
          default:
            break;
        }
      },
      /**
       * Закрывает выпадашку "Поделиться" если кликнуть мимо кнопки и выпадашки
       */
      clickOutside() {
        const btn = document.getElementById('shareBtn')
        document.addEventListener('click', event => {
          const isBtn = event.target === btn || btn.contains(event.target);
          if (!isBtn) this.openShare = false
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
